var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 65,
    viewBox: "0 0 38 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6627 23.9996L17.0855 9.82251C18.4855 5.33473 23.3077 2.80582 27.7954 4.20584C32.2832 5.60586 34.8121 10.428 33.4121 14.9158L20.0159 57.8574C19.051 60.9505 15.7573 62.6778 12.6643 61.7129C9.58762 60.7531 7.86081 57.4866 8.79599 54.4022L17.6257 25.2328L18.0275 23.9447C18.5701 22.2054 20.4215 21.2345 22.1608 21.7771C23.9001 22.3197 24.8711 24.1711 24.3285 25.9104L23.8371 27.4856",
    stroke: "#C8A898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8216,
    height: 61.1228,
    fill: "white",
    transform: "translate(19.0676 0.582764) rotate(17.326)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.6c1fd00e72a0293be480c50f64efcd4c.svg";
export { ForwardRef as ReactComponent };